export default __webpack_public_path__ + "static/media/pile 1 1.0a742e7b.png";